export default __webpack_public_path__ + "static/media/9.c2bcba9d.png";